import { z } from 'zod';
import { OutdoorBarArticleModelSchema } from 'entities/outdoor-bar-article';
import { GetOutdoorBarArticleByUidApiResponseSchema } from '../store';

// eslint-disable-next-line max-len
export const createOutdoorBarArticleFromGetOutdoorBarArticleApiResponse = (
    (response: z.infer< typeof GetOutdoorBarArticleByUidApiResponseSchema>) => (
        OutdoorBarArticleModelSchema.parse({
            uid: response.data.slug,
            name: response.data.name,
            description: response.data.description,
            category: response.data.category && {
                uid: response.data.category.slug,
                name: response.data.category.name,
            },
            images: response.data.images?.map(({ url }) => ({
                url,
            })),
            portions: response.data.portions?.map(({
                value,
                meassure,
                description,
                weight,
                price,
                currency,
            }) => ({
                value,
                meassure,
                description,
                weight,
                price,
                currency: currency && {
                    uid: currency.slug,
                    name: currency.name,
                    abbreviation: currency.abbreviation,
                },
            })),
            sets: response.data.sets?.map(({
                name,
                elements,
            }) => ({
                name,
                elements: elements?.map(({
                    name: name2,
                    meassure,
                    value,
                }) => ({
                    name: name2,
                    meassure,
                    value,
                })),
            })),
            includedServices: response.data.includedServices?.map(({
                name,
                description,
            }) => ({
                name,
                description,
            })),
            nonIncludedServices: response.data.nonIncludedServices?.map(({
                name,
            }) => ({
                name,
            })),
            recommendations: response.data.recommendations?.map(({
                slug,
                name,
                weight,
                price,
                currency,
                images,
            }) => ({
                uid: slug,
                name,
                weight,
                price,
                currency: currency && {
                    uid: currency.slug,
                    name: currency.name,
                    abbreviation: currency.abbreviation,
                },
                image: images?.[0] && {
                    url: images[0].url,
                },
            })),
        })
    )
);
